import React from 'react'
import { useConstrainable } from '@morningtrain/react-filters'
import useOnConstraintChange from 'support/hooks/use-on-constraint-change'

export default function useOnConstrainConstraint (constraint, callback) {
  const constrainable = useConstrainable()

  const triggerCallback = (routeName, parameters = {}) => {
    if (typeof callback === 'function') {
      callback(routeName, parameters)
    }
  }

  useOnConstraintChange(change => {
    if (change.name !== constraint) {
      return
    }

    if (['add', 'update'].includes(change.type)) {
      triggerCallback(constrainable.constraints)
    }
  })

  return null
}
